module.exports = __webpack_public_path__ + "static/assets/4b6e45367d8faa5bf16040c8a93cfd58.png";